<template>
    <page-loader :show="loader"/>
    <section-navigation v-if="!isNotFoundRoute"/>
    <section-sidebar v-if="!isNotFoundRoute"/>
    <main>
        <router-view/>
    </main>
    <section-hills-stars/>
</template>

<script>
import PageLoader from "@/components/page-loader.vue";
import SectionHillsStars from "@/components/section-hills-stars.vue";
import SectionSidebar from "@/components/section-sidebar.vue";
import SectionNavigation from "@/components/section-navigation.vue";
import router from "@/router";

export default {
    name: 'App',
    components: {
        SectionSidebar,
        SectionHillsStars,
        SectionNavigation,
        PageLoader,
    },
    computed: {
        isNotFoundRoute() {
            return this.$route.name === 'NotFound' || this.$route.name === 'not-found-catch-all';
        }
    },
    data() {
        return {
            loader: true,
            onKeyUp: null,
            onWindowLoad: null,
        };
    },
    created() {
        this.onKeyUp = (e) => {
            const html = document.documentElement;
            const navTrigger = document.querySelector('.nav-trigger');

            if (e.key !== 'Escape') {
                return;
            }

            if (html.classList.contains('content-active')) {
                html.classList.remove('content-active');
                router.push({path: '/'});
                return;
            }

            if (html.classList.contains('menu-active')) {
                if (navTrigger) {
                    navTrigger.style.display = 'block';
                }
                html.classList.remove('menu-active');
            }
        };

        this.onWindowLoad = () => {
            this.loader = false;
        };
    },
    mounted() {
        document.addEventListener('keyup', this.onKeyUp);

        if (document.readyState === 'complete') {
            this.loader = false;
        } else {
            window.addEventListener('load', this.onWindowLoad, {once: true});
        }
    },
    unmounted() {
        document.removeEventListener('keyup', this.onKeyUp);
        window.removeEventListener('load', this.onWindowLoad);
    }
};
</script>

<style lang="scss">
@import '@/assets/scss/style';
</style>
